import { useContext } from "react";

import ReducerContext from "../ReducerContext";

const useClientDispatch = () => {
  const { dispatch } = useContext(ReducerContext);

  return dispatch;
};

export default useClientDispatch;
